import { render } from "./P008.vue?vue&type=template&id=42430a27&scoped=true"
import script from "./P008.vue?vue&type=script&lang=js"
export * from "./P008.vue?vue&type=script&lang=js"

import "./P008.vue?vue&type=style&index=0&id=42430a27&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42430a27"]])

export default __exports__